<template>
  <FilterButton :title="title" @close="save" :active="selectedIndustries.length > 0" data-test="industry-filter" :badge="badgeCount">
    <template #menu="{ close }">
      <div class="menu">
        <h4>{{ subheader }}</h4>
        <div class="columns">
          <label class="filter-item" v-for="industry in industries" :key="industry.text">
            <input type="checkbox" v-model="selectedIndustries" :value="industry.value" data-test="filter-item-industry-checkbox"/>
            <span>{{ industry.text }}</span>
          </label>
        </div>
        <div class="buttons">
          <v-btn size="small" variant="outlined" @click="clear" data-test="filter-industry-clear">Clear</v-btn>
          <div>
            <v-btn class="mr8" variant="flat" size="small" color="secondary" @click="selectAll" data-test="filter-industry-select-all">Select All</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="close" data-test="filter-industry-apply">Apply</v-btn>
          </div>
        </div>
      </div>
    </template>
  </FilterButton>
</template>

<script>
import FilterButton from '@/components/FilterButton';

export default {
  name: 'IndustryFilter',
  components: { FilterButton },
  props: {
    value: Array,
    industries: Array,
    showBadge: Boolean,
    subheader: { required: false, type: String, default: 'Industries' },
  },
  data() {
    return {
      dirty: false,
      selectedIndustries: []
    };
  },
  computed: {
    title() {
      if (this.selectedIndustries.length === 1) {
        return this.industries.find(i => this.selectedIndustries[0] === i.value)?.text || this.selectedIndustries[0];
      }
      return 'Industry';
    },
    badgeCount() {
      return this.showBadge ? this.selectedIndustries.length : 0;
    }
  },
  methods: {
    clear() {
      this.selectedIndustries = [];
    },
    save() {
      if (this.dirty) {
        this.dirty = false;
        this.$emit('update:modelValue', this.selectedIndustries);
      }
      return true;
    },
    selectAll() {
      this.selectedIndustries = this.industries.map(x => x.value);
    }
  },
  watch: {
    selectedIndustries() {
      this.dirty = true;
      this.$emit('input', this.selectedIndustries);
    }
  }
};
</script>

<style scoped>
.mr8 {
  margin-right: 8px;
}

.menu {
  padding: 1rem 0 0 0;
  min-width: 500px;
}

.menu > h4 {
  padding: 0 1rem;
}

.menu > .columns {
  padding: 0.5rem;
  margin: 0.5rem 1rem 1rem;
  max-height: 300px;
  overflow-y: scroll;
  border: 1px solid var(--v-border-base);
}

.menu > .columns > label {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
  align-content: center;
  align-items: center;
  padding: 0.2rem 0;
  cursor: pointer;
  user-select: none;
}

.menu > .buttons {
  padding: 1rem;
  border-top: 1px solid var(--v-border-base);
  background: var(--v-gray-lighten5);
  display: flex;
  justify-content: space-between;
}
</style>
